import type { JSONSchemaType } from 'ajv';

export type StateRequestSchema = {
  
}

export const stateRequestSchema: JSONSchemaType<StateRequestSchema> = {
  type: 'object',
  properties: {
    
  },
  additionalProperties: false,
}